import { Box, TextField, Typography, Link } from '@mui/material';
import React from 'react';
import { color, font, space } from '../../shared/ui';

const colors = { background: color.white, primary: color.brand, text: color.black };

export default function Field({
  disabled = false,
  helpLinkOnClick = () => {},
  helperLinkText,
  label,
  maxLength,
  onChange,
  textAlign = 'left',
  type,
  value,
}) {
  return (
    <Box sx={{ width: 428, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          mb: space[8],
          px: space[20],
        }}
      >
        <Typography sx={{ fontSize: font.size.body, color: colors.text }}>
          {label} <span style={{ color: color.errorText }}>*</span>
        </Typography>
        {!!helperLinkText && (
          <Link
            component="button"
            type="button"
            onClick={helpLinkOnClick}
            sx={{
              color: colors.primary,
              textDecoration: 'underline',
              fontSize: font.size.caption,
            }}
          >
            {helperLinkText}
          </Link>
        )}
      </Box>
      <TextField
        type={type}
        value={value}
        onChange={onChange}
        required
        fullWidth
        disabled={disabled}
        variant="standard"
        {...(maxLength ? { inputProps: { maxLength } } : {})}
        sx={{
          fontSize: font.size.lead,
          textAlign,
          '& .MuiInputBase-input': {
            textAlign: `${textAlign} !important`,
            color: colors.text,
            fontSize: font.size.lead,
            minHeight: '36px',
            padding: '0px 0px 0px 20px',
            border: 'none',
            outline: 'none',
          },
          '& .MuiInput-underline:before': { borderBottom: '1px solid lightgrey' },
          '& .MuiInput-underline:after': { borderBottom: '1px solid lightgrey' },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '1px solid lightgrey',
          },
        }}
      />
    </Box>
  );
}
